import { Tooltip, Typography } from "antd";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import CustomerIdCell from "src/utils/customerIdCell";
import { CheckOutlined } from '@ant-design/icons';

const { Text } = Typography;

export const DateColumnHandler = ({data}) => {
    const date=data?.dataItem?.createdDate;
    return (
        <td>
            <div className="gridLink text-light-valueColor">
                {date ? <> {moment.utc(date).local().format("DD/MM/YYYY hh:mm:ss A")}</> : date}
            </div>           
        </td>
    )
}
export const StatusColumnHandler = ({data,badge}) => {
    const state = data?.dataItem?.state
    return (
        <td> <span className={`status-badge ${badge[state?.toLowerCase()] || 'bg-green'}`}>{state}</span></td>

    )
}

export const NumberFormatter = ({ value }) => {
    return<td>
      <NumericFormat 
        value={value} 
        decimalScale={2} 
        thousandSeparator={true} 
        thousandsGroupStyle="lakh" 
        displayType="text" 
      />
    </td>
};

export const TransactionsIdColumnHandler = ({data,copiedId,handleIdCopy}) => {
    const tradeId = data?.dataItem?.tradeId;
    return (<td>
    <CustomerIdCell customerId={tradeId} copied={copiedId} handleCopy={handleIdCopy}/>
    </td>)
}


export const CardNumberHandlerColumnHandler = ({data,copied,handleCopy}) => {
        const cardNumberorAddress = data?.dataItem?.cardNumber;
        let shortAddress
        if(data?.dataItem?.txType=="Wallet Deposit"){
          shortAddress=`${cardNumberorAddress.substring(0, 8)}....${cardNumberorAddress.substring(cardNumberorAddress.length - 8)}`
        }
        else{
          shortAddress=cardNumberorAddress
        }
        return (
          <td style={{paddingRight:25}}>
              {cardNumberorAddress && copied!==data?.dataItem?.tradeId&&
              <Text key={data?.dataItem?.tradeId} className="text-whiteText flex justify-between" copyable={{ text: cardNumberorAddress, onCopy:()=> handleCopy(data?.dataItem?.tradeId) }} options={{ format: 'text/plain' }} >
                <span>{shortAddress}</span>
              </Text>}
              {copied===data?.dataItem?.tradeId &&
                    <Text className="text-whiteText flex justify-between " key={data?.dataItem?.tradeId}>
                      <span>{shortAddress}</span>
                      <Tooltip title="Copied" open={copied}>
                        <CheckOutlined  style={{ marginLeft: 8, color: 'green' }} />
                      </Tooltip>
                    </Text>}
          </td>
        );
     
}